import { useContext } from 'react'

import { KpiSalesContext } from '@provider/Kpi/SalesProvider'

import type { IKpiSalesContext } from '@base/@types/providers/Kpi/SalesProvider'

export default function useKpiSales(): IKpiSalesContext {
  const context = useContext(KpiSalesContext)

  return context
}
